module.exports = __webpack_public_path__ + "img/factory.02592792.svg";